// apps/landing-page/src/lib/exam-icons.ts
import {
  BookOpen,
  Briefcase,
  Globe,
  GraduationCap,
  Headphones,
  NotebookPen,
  Puzzle,
  School,
  type LucideIcon,
} from 'lucide-react';

// Keyed by exam-type slug. An unknown slug falls back to a book, so a new exam
// family added in the admin panel still renders.
const EXAM_ICONS: Record<string, LucideIcon> = {
  tka: NotebookPen,
  utbk: GraduationCap,
  cpns: Briefcase,
  toefl: Headphones,
  toeic: Globe,
  mandiri: School,
  psikotes: Puzzle,
};

export function examIcon(slug: string): LucideIcon {
  return EXAM_ICONS[slug] ?? BookOpen;
}
